import { render, staticRenderFns } from "./OrderBy.vue?vue&type=template&id=0c6a00ae&scoped=true"
import script from "./OrderBy.vue?vue&type=script&lang=js"
export * from "./OrderBy.vue?vue&type=script&lang=js"
import style0 from "./OrderBy.vue?vue&type=style&index=0&id=0c6a00ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a00ae",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
